var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-item",
    {
      attrs: {
        "data-test": _vm.CypressTarget("MySingleSeatItem"),
        multiline: ""
      }
    },
    [
      _c(
        "q-item-side",
        [_c("q-item-tile", { attrs: { icon: "event_seat" } })],
        1
      ),
      _c(
        "q-item-main",
        [
          _c(
            "q-item-tile",
            { attrs: { "data-test": _vm.CypressTarget("Label"), label: "" } },
            [_vm._v("\n      " + _vm._s(_vm.itemLabel) + "\n    ")]
          ),
          _c(
            "q-item-tile",
            {
              attrs: {
                "data-test": _vm.CypressTarget("SubLabel"),
                sublabel: ""
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.itemSubLabel) + "\n    ")]
          ),
          _vm.gate
            ? _c(
                "q-item-tile",
                {
                  attrs: {
                    "data-test": _vm.CypressTarget("SubLabel"),
                    sublabel: ""
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.gate) + "\n    ")]
              )
            : _vm._e(),
          _vm.showPrice
            ? _c(
                "q-item-tile",
                {
                  staticStyle: { "margin-bottom": "5px" },
                  attrs: {
                    "data-test": _vm.CypressTarget("Name"),
                    sublabel: ""
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        "" + (_vm.quantity > 1 ? _vm.quantity + "x " : "")
                      ) +
                      _vm._s(_vm.title) +
                      "\n      "
                  ),
                  _vm.description.length > 0
                    ? _c("div", { staticClass: "text-description" }, [
                        !_vm.showFullDescription
                          ? _c("p", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.sortDescription) +
                                  "\n          "
                              ),
                              _vm.fullDescription.length > 100
                                ? _c("span", [
                                    _vm._v("...\n            "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "read-more",
                                        on: {
                                          click: _vm.toggleShowFullDescription
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("button.showMore"))
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _c("p", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.fullDescription) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "read-more",
                                  on: { click: _vm.toggleShowFullDescription }
                                },
                                [_vm._v(_vm._s(_vm.$t("button.showLess")))]
                              )
                            ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm.price > 0 &&
          (_vm.extraAmounts.length > 0 ||
            (_vm.showConvenienceFee && _vm.convenienceFee))
            ? _c(
                "q-item-tile",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    "margin-bottom": "5px",
                    "font-size": ".8em"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column text-muted mb-0 text-description text-grey-7"
                    },
                    [
                      !_vm.newTaxesView
                        ? _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("label.ticket")) +
                                ": " +
                                _vm._s(_vm.ticketPriceWithoutDiscount) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm.hasCoupon && !_vm.newTaxesView
                        ? _c("div", { staticClass: "q-mt-xs" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("label.couponDiscount")) +
                                ": -" +
                                _vm._s(_vm.formatMoney(_vm.discount)) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._l(_vm.extraAmounts, function(extra_amount, i_extra) {
                        return _c(
                          "div",
                          { key: "extra" + i_extra, staticClass: "q-mt-xs" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  extra_amount.name +
                                    ": " +
                                    _vm.formatMoney(extra_amount.amount)
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      }),
                      _vm.showConvenienceFee &&
                      _vm.convenienceFee &&
                      !_vm.newTaxesView
                        ? _c("div", { staticClass: "q-mt-xs" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("label.convenienceFee")) +
                                ": " +
                                _vm._s(_vm.formatMoney(_vm.convenienceFee)) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            : _vm.hasCoupon && !_vm.newTaxesView
            ? _c(
                "q-item-tile",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    "margin-bottom": "5px",
                    "font-size": ".8em"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column text-muted mb-0 text-description text-grey-7"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("label.ticket")) +
                          ": " +
                          _vm._s(_vm.ticketPriceWithoutDiscount) +
                          "\n        "
                      ),
                      _c("div", { staticClass: "q-mt-xs" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("label.couponDiscount")) +
                            ": -" +
                            _vm._s(_vm.formatMoney(_vm.discount)) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm.showPrice
            ? _c(
                "q-item-tile",
                {
                  attrs: {
                    "data-test": _vm.CypressTarget("Price"),
                    sublabel: _vm.priceAsSubLabel
                  }
                },
                [
                  _vm.newTaxesView
                    ? _c(
                        "div",
                        { staticClass: "ticket-price" },
                        [
                          _c(
                            "coupon-tag",
                            _vm._b(
                              {},
                              "coupon-tag",
                              {
                                price: _vm.price,
                                hasTrueDiscount: _vm.hasTrueDiscount,
                                isHiddenPrice: _vm.isHiddenPrice,
                                hasCoupon: _vm.hasCoupon
                              },
                              false
                            )
                          ),
                          _c("div", [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.hasCoupon && _vm.hasTrueDiscount
                                    ? "has-coupon d-inline"
                                    : "d-inline"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.ticketPriceWithoutDiscount) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm.hasCoupon && _vm.hasTrueDiscount
                              ? _c("div", { staticClass: "d-inline q-ml-sm" }, [
                                  _c("i", {
                                    staticClass: "far fa-long-arrow-right"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.ticketPrice) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm.showConvenienceFee && _vm.convenienceFee
                            ? _c(
                                "div",
                                { staticClass: "q-mt-xs text-description" },
                                [
                                  _vm._v(
                                    "\n          (+ " +
                                      _vm._s(
                                        _vm.formatMoney(_vm.convenienceFee)
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("label.taxes")) +
                                      ")\n        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(
                          "\n        " + _vm._s(_vm.totalPrice) + "\n      "
                        )
                      ])
                ]
              )
            : _vm._e(),
          _vm.holder
            ? _c(
                "q-item-tile",
                {
                  attrs: {
                    "data-test": _vm.CypressTarget("HolderLabel"),
                    sublabel: ""
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.seatHolderLabel
                          ? _vm.$t("label.seatHolder")
                          : _vm.$t("label.ticketHolder")
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm.holder
            ? _c(
                "q-item-tile",
                {
                  attrs: { "data-test": _vm.CypressTarget("Holder"), label: "" }
                },
                [_vm._v("\n      " + _vm._s(_vm.holder) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "q-item-side",
        { attrs: { "data-test": _vm.CypressTarget("Buttons"), right: "" } },
        [
          _c(
            "q-item-side",
            { attrs: { "data-test": _vm.CypressTarget("Buttons"), right: "" } },
            [
              _c("button-remove", {
                attrs: { disable: _vm.loading, loading: _vm.isLoading },
                on: { click: _vm.removeSeatAction }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }